import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_URL, CREDIT_SUMMARY } from "../constant";

export const fetchCreditSummary=createAsyncThunk(
    "/credit/summary",
    async (_, thunkAPI)=>{
        const state = thunkAPI.getState()
        const access_token = state.User.access_token
        const response= await axios.get(`${BASE_URL}${CREDIT_SUMMARY}`,{
            headers:{
                Authorization:`Bearer ${access_token}`
            }
        });
        return response.data.data
    }
)


const CreditSlice=createSlice({
    name:"credit",
    initialState:{
        data:[],
        loading:false,
        error:null
    },
    reducers:{

            clearCredit: (state) => {
              state.data = [];
          }
    },
    
    extraReducers:(builder)=>{
        builder
        .addCase(fetchCreditSummary.pending, (state) => {
            state.loading = true;
          })
    
          .addCase(fetchCreditSummary.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
          })
    
          .addCase(fetchCreditSummary.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
          })
    }
})
export const { clearCredit } = CreditSlice.actions;

export default CreditSlice.reducer;